import type { ActionItem } from "@/admin/ActionItem.tsx";
import {
    type UnassignFloatingIpModalProps,
    UnassignFloatingIpModalContent,
} from "@/admin/floating_ips/UnassignFloatingIpBlock.tsx";
import { DISABLED } from "@/components/Action.tsx";
import { showModal } from "@/components/modal/registerModal.tsx";

export function unassignAction(item: UnassignFloatingIpModalProps | null): ActionItem {
    return {
        id: "unassign_ip",
        title: "Unassign IP",
        icon: "jp-wrong-icon",
        action: item == null ? DISABLED : () => showModal(<UnassignFloatingIpModalContent {...item} />),
    };
}
